import { render } from "./PopupLayout.vue?vue&type=template&id=0990a3da"
import script from "./PopupLayout.vue?vue&type=script&lang=js"
export * from "./PopupLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__